export const citizenBaseUrl = "/digit-ui/citizen";
export const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
export const Sidebarlabels = [
  { text: "Dashboard", path: `${citizenBaseUrl}/profile` },
  { text: "Edit Profile", path: `${citizenBaseUrl}/user/profile` },
  { text: "My Applications", path: `${citizenBaseUrl}/obps/ownerApplications` },
  { text: "Back to Home Page", path: `${citizenBaseUrl}` },
  { text: "Logout", path: `${citizenBaseUrl}` },
];
export const SidebarLabelsLandUse = [
  { text: "Dashboard", path: `${citizenBaseUrl}/profile` },
  { text: "Edit Profile", path: `${citizenBaseUrl}/user/profile` },
  { text: "My Applications", path: `${citizenBaseUrl}/obps/formLandUseApplications` },
  { text: "Back to Home Page", path: `${citizenBaseUrl}` },
  { text: "Logout", path: `${citizenBaseUrl}` },
];
export const SideBarLabelsFAR = [
  { text: "Dashboard", path: `${citizenBaseUrl}/profile` },
  { text: "Edit Profile", path: `${citizenBaseUrl}/user/profile` },
  { text: "My Applications", path: `${citizenBaseUrl}/obps/purchasableFarApplications` },
  { text: "Back to Home Page", path: `${citizenBaseUrl}` },
  { text: "Logout", path: `${citizenBaseUrl}` },
];
export const LTPSidebarlabels = [
  { text: "Dashboard", path: `${citizenBaseUrl}/profile` },
  { text: "Edit Profile", path: `${citizenBaseUrl}/user/profile` },
  { text: "My Applications", path: `${citizenBaseUrl}/obps/formProfessionalApplications` },
  { text: "Back to Home Page", path: `${citizenBaseUrl}` },
  { text: "Logout", path: `${citizenBaseUrl}` },
];
export const landUseSubTabLabels = [
  // { text: "Verifying Authority" },
  { text: "Property Owner/Applicant Details" },
  { text: "Licensed Technical Professional (LTP) Information" },
  { text: "Land/Plot Information" },
];
export const landUseSubTabDDocSecLabels = [{ text: "Mandatory Documents" }, { text: "Conditional Documents" }];
export const farSubTabLabels = [{ text: "Verifying Authority" }, { text: "Applicant Details" }, { text: "Layout Details" }, { text: "FAR Details" }];
//Below label is for LAND USE
export const primaryTabLabels = [
  { text: "Land Use Verification" },
  { text: "Documents" },
  // { text: "Location Map" },
  // { text: "NOC Checklist" },
  { text: "Summary" },
];
//Below label is for Purchasable FAR
export const farPrimaryLabels = [
  { text: "Applicant Details" },
  { text: "Documents" },
  { text: "Checklist" },
  // { text: "Location Map" },
  { text: "Summary" },
];
export const MSSidebarlabels = [
  { text: "Dashboard", path: `${citizenBaseUrl}/profile` },
  { text: "Edit Profile", path: `${citizenBaseUrl}/user/profile` },
  { text: "My Applications", path: `${citizenBaseUrl}/obps/mapSubApplications` },
  { text: "Compounding Applications", path: `${citizenBaseUrl}/obps/compoundingApplications` },
  { text: "Back to Home Page", path: `${citizenBaseUrl}` },
  { text: "Logout", path: `${citizenBaseUrl}` },
];
